import {REST_METHODS} from '@/src/app/constants/api';
import authorizedFetch from '@/src/app/utils/authorizedFetch';

const requestDeleteAccount = (remove_immediately) => {
  // @ts-ignore
  return authorizedFetch({
    method: REST_METHODS.POST,
    path: `/api/v1/profiles/delete_account_requests`,
    body: {
      remove_immediately,
    },
  });
};

export default requestDeleteAccount;
